import { store as app } from '@/app'

export default { app }



// WEBPACK FOOTER //
// ./src/store/modules.js